export default {
  text: 'IDRA is a member of ESOMAR and certified with ISO 20252-2012 the international standard for Market, opinion and social research and ISO 9001 2008 for Quality and Safety Control',
  contact: 'Contact',
  termsAndConditions: 'Terms and conditions',
  unSubcribe: 'Unsubscribe',
  coppyRight: ' © Copyright IDRA. All Rights Reserved',
};
